import { Link } from 'react-router-dom';
import styles from './NotFoundPage.module.css';

export function NotFoundPage() {
  return (
    <div className={styles.wrap}>
      <h2>Page not found</h2>
      <p>
        <Link to="/cave">Back to accomplishments</Link>
      </p>
    </div>
  );
}
